import {api} from '../middleware/api';
import {sseClient} from '../../services/sseClient';

// Define endpoints using injectApi pattern
export const dashboardApi = api.injectEndpoints({
  endpoints: builder => ({
    getDashboards: builder.query<any, any>({
      query: ({cid, dt}) => `dashboard/${cid}/${dt}`,
      // Without this, invalidateTags(['Collection']) below has nothing to
      // invalidate - no endpoint provided that tag, so SSE-driven dashboard
      // refreshes were a no-op and the dashboard only ever updated on a full
      // remount (navigating away and back).
      providesTags: ['Collection'],
      async onCacheEntryAdded(
        _arg,
        {cacheDataLoaded, cacheEntryRemoved, dispatch},
      ) {
        try {
          await cacheDataLoaded;
          const unsubscribe = sseClient.addListener(data => {
            if (
              data.type === 'FRONT_OFFICE_UPDATED' ||
              data.type === 'POS_ORDER_UPDATED'
            ) {
              dispatch(dashboardApi.util.invalidateTags(['Collection']));
            }
          });
          await cacheEntryRemoved;
          unsubscribe();
        } catch {
          // no-op
        }
      },
    }),
    // Restaurant income (POS sales) vs expense (store + POS counter issue),
    // one row per period (DAY/WTD/MTD for mode W). DECIMALs arrive as strings.
    getDashboardRestaurant: builder.query<
      any[],
      {cid: string; dt: string; mode: 'W' | 'Y'}
    >({
      query: ({cid, dt, mode}) =>
        `dashboard/restaurant/${cid}/${encodeURIComponent(dt)}?mode=${mode}`,
      // 'Collection' is the only tag in this app; the SSE listener above invalidates it
      providesTags: ['Collection'],
    }),
    getDate: builder.query<any, any>({
      query: cid => `dashboard/${cid}`,
    }),
  }),
  overrideExisting: true,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetDashboardsQuery,
  useGetDashboardRestaurantQuery,
  useGetDateQuery,
  useLazyGetDateQuery,
} = dashboardApi;

